//Vishy 2025-02-17 Code updated for UI headings and correct calculation of values for the admin panel.

import { Box, Button, Flex, Text, Textarea } from "@chakra-ui/react";
import { useEffect, useState, useRef } from "react";
import { AdminAPI } from "../../Apis/adminAPI";
import Loader from "../../Components/Loader/Loader";
import { MdArrowDropDown, MdArrowDropDownCircle } from "react-icons/md";
import { EventInterface, BuyerInterface} from "../../Interface/CommonInterface";
import moment from "moment";
import { useLocation } from "react-router-dom";
import { IoMdArrowDropright } from "react-icons/io";
import { Select } from "antd";
import { useToastWrapper } from "../../Wrapper/toastWrapper";
import { useNavigate, useParams } from "react-router-dom";


type Props = {};

const BuyerRewards = (props: Props) => {
  const location = useLocation();
  const { buyerId } = location.state || {};
  const { error } = useToastWrapper();
  const notesRef = useRef<HTMLTextAreaElement | null>(null);
  const [loading, setLoading] = useState(false);
  const [rewards, setRewards] = useState<any[]>([]);
  const [redemptions,setRedemptions] = useState<any[]>([]);
  const [redemptionsSummary, setRedemptionsSummary] = useState<any>({});
  const [pointsInHand, setPointsInHand] = useState<number>(0);
  const [rrId, setRRID]= useState<string>(""); 
  const [rrIdCurrentStatus, setRRIDCurrentStatus] = useState<string>(""); 
  const [redemptionNotes,setRedemptionNotes] = useState<string>(""); 
  const [rrIdInProgressPoints, setRRIDInProgressPoints] = useState<number>(0);
  const [rrIdInProgressValue, setRRIDInProgressValue] = useState<number>(0);
  const [rrIdRedeemedPoints, setRRIDRedeemedPoints] = useState<number>(0);
  const [rrIdRedeemedValue, setRRIDRedeemedValue] = useState<number>(0);
  const [totalInProgressPoints, setTotalInProgressPoints] = useState<number>(0);
  const [totalInProgressValue, setTotalInProgressValue] = useState<number>(0);
  const [totalredeemedPoints, setTotalRedeemedPoints] = useState<number>(0);
  const [totalRedeemedValue, setTotalRedeemedValue] = useState<number>(0);
  const [accordian, setAccordian] = useState<number>(-1);
  const [redemptionStatusDropDown, setRedemptionStatusDropDown] = useState<string>(""); 
  const [notes, setNotes] = useState<string>("");
  const [uniqueRedemptionRequestIds, setUniqueRedemptionRequestIds] = useState<any[]>([]);
  const [eventId, setEventId] = useState<string>(""); 
  const [eventTitle, setEventTitle] = useState<string>(""); 
  const [buyer, setBuyer] = useState<BuyerInterface>();

  const getRewardsAndEvents = async () => {
    console.log("BuyerRewards.tsx Page loading with buyerId:",buyerId);
    let eventID;
    try {
      setLoading(true);
      const [eventObject, buyerObject] = await Promise.all([
        AdminAPI.getEvent(),
        AdminAPI.getBuyerById(buyerId),
      ]);
      console.log("VistorRewards.tsx AdminAPI.getEvent eventObject:",eventObject);
      console.log("VistorRewards.tsx AdminAPI.getBuyerById buyerObject",buyerObject);
      
      if (eventObject) {
        eventID = eventObject.data.data[0]._id;
        console.log("eventID=",eventID);
        setEventId(eventObject.data.data[0]._id);//Assigns the fetched eventId
        setEventTitle(eventObject.data.data[0].eventName);//Assigns the fetched eventId
      }
      
      if (buyerObject) {
        const params: any = {};
        params["buyerId"] = buyerObject.data.data._id; // Assigns the feched buyerId as params
        setBuyer(buyerObject.data.data);
        console.log("BuyerRewards.tsx params is:", params);
        console.log("BuyerRewards.tsx input eventId for getRedemptionSummary is:",eventID)
        console.log("BuyerRewards.tsx input buyerId for getRedemptionSummary is:",buyerId)

        const [rewardsObject, redemptionsObject, redemptionsSummaryObject] = await Promise.all([
          AdminAPI.getRewardsByBuyerId(params),
          AdminAPI.getRedemptions(params),
          AdminAPI.getRedemptionsSummary(eventID,buyerId)
        ]);
        
        console.log("BuyerRewards.tsx AdminAPI.getRewardsByBuyerId rewardsObject:",rewardsObject);
        console.log("BuyerRewards.tsx AdminAPI.getRedemptions redemptionsObject",redemptionsObject);
        console.log("BuyerRewards.tsx AdminAPI.getRedemptionsSummary redSumObject",redemptionsSummaryObject);

        if (rewardsObject) {
          const rewardsData = rewardsObject.data.data.rewards;
          setRewards(rewardsData);
          console.log("Rewards", rewardsData);
        
          if (rewardsData.length > 0) {
            setPointsInHand(rewardsData[0].closingBalance);
          }
        }

        if (redemptionsObject) {
          const redemptionsData = redemptionsObject?.data;
          console.log("Unsorted RedemptionData is",redemptionsData);
        
          if (Array.isArray(redemptionsData)) {
            // Sort the redemptions array before setting state
            redemptionsData.sort((a: any, b: any) => b.updatedAt - a.updatedAt);
            setRedemptions(redemptionsData);
            console.log("Sorted Redemptions Array is:", redemptionsData);
            
            // Create a unique list of RRIDs from the redemptions collection
            const uniqueRRIDs = redemptionsData.reduce<string[]>((acc, item) => {
              if (!acc.includes(item.redemptionRequestId)) {
                acc.push(item.redemptionRequestId);
              }
              return acc;
            }, []);
            setUniqueRedemptionRequestIds(uniqueRRIDs);
          }
        }
                
        if (redemptionsSummaryObject) {
          setRedemptionsSummary(redemptionsSummaryObject);
        }    
      } 
    } catch (err: any) {
      console.log(err);
    } finally {
      //setAccordian(-1);
      setLoading(false);
    }
  };
 
  const handleUpdateRedemption = async (redemptionId: string,newRedemptionStatus: string) => {
    console.log("Now entering handleUpdateRedemption");
    console.log("BuyerRewards.tsx input redemption id for getLatest... is ",redemptionId);
    console.log("New status to be set:",newRedemptionStatus);
  
    if(newRedemptionStatus == ''){
      error("Redemption Status not selected", "");
      return;
    }

    if(notesRef.current?.value.trim() === ''){
      error("Please fill the redemption notes", "");
      return;
    }
   
    //await fetchLatestRedemptionDetails(redemptionId);

    //Fetch Latest Redemption Details
    const redemptionByRRIDObject = await AdminAPI.getLatestRedemptionByRRID({ redemptionRequestId: redemptionId });
    console.log("LatestRedemptionbyRRID Object is:",redemptionByRRIDObject);

    //Check if the current redemption status in database is "Completed"
    console.log("rrIdCurrentStatus is:",redemptionByRRIDObject.data.redemptionStatus);
    if (redemptionByRRIDObject.data.redemptionStatus === "Completed" && newRedemptionStatus === "In Progress") {
      error(" Redemption status cannot be changed to 'In Progress' once it is 'Completed'.", "");
      return;
    }
  
    if (redemptionByRRIDObject?.data) {
        const latestRedemption = redemptionByRRIDObject.data;       
        //sending the redemption object to the redemptionservice
        try {
            await AdminAPI.updateRedemption({
              eventId: latestRedemption.eventId,
              buyerId: latestRedemption.buyerId,
              redemptionRequestId: latestRedemption.redemptionRequestId,
              redemptionStatus: newRedemptionStatus,
              redemptionNotes: notesRef.current?.value,
              rrIdInProgressPoints: latestRedemption.rrIdInProgressPoints,
              rrIdInProgressValue: latestRedemption.rrIdInProgressValue,
              rrIdRedeemedPoints: latestRedemption.rrIdRedeemedPoints || 0,
              rrIdRedeemedValue: latestRedemption.rrIdRedeemedValue || 0
            });
            setNotes("");
            if (notesRef.current) {
              notesRef.current.value = "";
            }
            setRedemptionStatusDropDown("");
            getRewardsAndEvents();
        } catch (error) {
          console.error("Error updating redemption:", error);
        }
      }
    }


  useEffect(() => {getRewardsAndEvents();},[]);

  /*Vishy 2025-03-07 Temporarily switching off useEffect for testing

  useEffect(() => {
    console.log("Updated Unique Redemptions:", uniqueRedemptionRequestIds);
  }, [uniqueRedemptionRequestIds]);

  useEffect(() => {
    console.log("Updated Redemptions Summary:", redemptionsSummary);
  }, [redemptionsSummary]);
    
  */ 

  return (
    <div className="p-4">
      {/* {loading ? <Loader /> : null} */}

      <Flex
        justifyContent={"center"}
        mt={"10px"}
        padding={"10px 0px"}
        backgroundColor={"primary.main"}
        >
        <Text fontSize={"24px"} fontWeight={600} className="text-[#FFFFFF]">
          Buyer Rewards & Redemptions
        </Text>
      </Flex>
      <Flex
        justifyContent={"space-around"}
        padding={"10px 0px"}
        borderBottomColor={"primary.main"}
        borderBottom={"2px solid"}
      >
        <Text size={"lg"} fontWeight={600}>
          {eventTitle}
        </Text>

        <Text size={"lg"} fontWeight={600}>
          {buyer?.buyerPersonName}
        </Text>
        
        <Text size={"lg"} fontWeight={600}>
          {buyer?.buyerCompanyName}
        </Text>

      </Flex>
      <Flex justifyContent={"space-around"}
            padding={"10px 0px"}
            borderBottomColor={"primary.main"}
            borderBottom={"2px solid"}
      >
        <Text size={"lg"} fontWeight={600}>
          Reward Points In Hand:{rewards[0]?.closingBalance ?? 0}
        </Text>
        
        <Text size={"lg"} fontWeight={600}>
          Redemption In Progress: {redemptionsSummary?.data?.totalInProgressPoints ?? 0}
        </Text>
        
        <Text size={"lg"} fontWeight={600}>
          Redeemed Points: {redemptionsSummary?.data?.totalRedeemedPoints ??0}
        </Text>
      
      </Flex>
      
      <Flex justifyContent={"center"} mt={"10px"} padding={"10px 0px"}>
        <Text fontSize={"24px"} fontWeight={600}> 
          Redemptions Statement  
        </Text> 
      </Flex>
      
      <Box>
      { uniqueRedemptionRequestIds.length > 0 ?
       ( uniqueRedemptionRequestIds.map((field, index) => (
          <Box>
            <Flex
              alignItems={"center"}
              gap={"10px"}
              mt={"10px"}
              padding={"10px 0px"}
            >
              {accordian != index ?
               (<IoMdArrowDropright 
                  size={"30px"}
                  onClick={() => {setAccordian(index);}}
              />) : 
                (<MdArrowDropDown 
                  size={"30px"}
                  onClick={() => {setAccordian(-1);}}
                />
                )
              }

              <Text size={"lg"} fontWeight={600}>{field}</Text>
              <Text size={"lg"} fontWeight={600}>
                {redemptions.filter(item => item.redemptionRequestId === field)[0].redemptionStatus}
              </Text>
            </Flex>
            
            {accordian == index && (
            <Box sx={{ paddingLeft: "10px"}}>
              <Text paddingLeft={"10px"}>
                In Progress Points: {redemptions[index].rrIdInProgressPoints}{" "},
                In Progress Value:{redemptions[index].rrIdInProgressValue}{" "},
                Redeemed Points:{redemptions[index].rrIdRedeemedPoints}{" "},
                Redeemed Value:{redemptions[index].rrIdRedeemedValue}
              </Text>
              <br />
              <Text paddingLeft={"10px"}>
                {moment(redemptions[index].createdAt)?.format("DD/MMM/YYYY hh:mm A")}{" "},
                Previous Notes:
                {redemptions[index].redemptionNotes}
              </Text>
            
              <Flex gap={"40px"} mt={"10px"} padding={"10px"}>
                <Text paddingLeft={"10px"}><strong>Redemption Status</strong></Text>
                <Select
                  className="custom-select-noborder"
                  showSearch
                  style={{width: "30%",border: "1px solid #D9D9D9",height: "50px"}}
                  value={redemptionStatusDropDown}
                  onChange={(e) => {setRedemptionStatusDropDown(e);}}
                  placeholder="Redemption Status"
                  optionFilterProp="children"
                  options={[
                    {label: "In Progress",value: "In Progress"},
                    {label: "Completed",value: "Completed"},
                  ]}
                />
                
                <Text paddingLeft={"10px"}><strong>Redemption Notes</strong></Text>
                <Textarea
                  style={{width: "30%",border: "1px solid #D9D9D9",borderRadius: 0}}
                  rows={6}
                  placeholder="Redemption notes will be shown to the buyer"
                  ref={notesRef}
                />
                
                <Box display={"flex"} width={"30%"} justifyContent={"left"}>
                  <Button
                    display={"flex"}
                    justifyContent={"center"}
                    alignItems={"center"}
                    background={"primary.main"}
                    color={"white"}
                    padding={"10px"}
                    onClick={() => {handleUpdateRedemption(field,redemptionStatusDropDown);}}
                  >
                    Add Notes
                  </Button>
                </Box>
              </Flex>
            </Box>
            )}
          </Box>
        ))
        ) : (
        <Text textAlign="center" mt="10px" fontSize="18px" fontWeight="500">
          No redemptions found.
        </Text>
        )
      }
      </Box>
    </div>
  );
}

export default BuyerRewards; 


//In the routes file, the import is AdminBuyerRewards. 
//The 'default' option here allows this to be exported as BuyerRewards instead of AdminBuyerReward
